export default __webpack_public_path__ + "static/media/aftereffects-logo.8dc0f0af.svg";